module.exports = __webpack_public_path__ + "static/pdf-b832b30eb1820d0f124c19250968b599.png";